<template>
  <Transition>
    <div
      class="verify-modal"
      v-show="visible"
      width="310">
      <div class="verify-modal-header">
        <div class="verify-modal-title">
          完成拼图验证
        </div>
        <Icon
          type="ios-close"
          class="verify-modal-close"
          @click="cancel"
          size="30"/>
      </div>
      <Verify
        @success="success"
        :mode="'fixed'"
        :captcha-type="'blockPuzzle'"
        :v-space="16"
        :img-size="{ width: '288px', height: '120px' }"
        ref="verify"
      ></Verify>
    </div>
  </Transition>
</template>
<script lang="jsx">
import Verify from '../verifition/Verify';
export default {
  components: {Verify},
  data() {
    return {
      visible: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.visible = false;
    },
    open() {
      this.visible = true;
    },
    success(captchaVerification) {
      this.cancel();
      this.$emit('success', captchaVerification);
    },
  },
};
</script>
<style lang="scss" scoped>
.verify-modal {
  position: absolute;
  top: 95px;
  left: 17px;
  background-color: #fff;
  z-index: 999;
  padding: 8px 16px 16px;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.20);
  .verify-modal-header{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    margin-top: 8px;

    .verify-modal-close{
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
